import { createSlice } from "@reduxjs/toolkit";


const patientsSlice = createSlice({
    name: 'patients',
    initialState: {
        patients: [],
        loading: false,
        error: null,
        patientsCount: 0,
        resPerPage: 3
    },
    reducers: {
        productsRequest(state, action){
            return {
                loading: true
            }
        },
        patientsSuccess(state, action){
            return {
                loading: false,
                patients: action.payload.patients,
                patientsCount:action.payload.count,
                resPerPage:action.payload.resPerPage
            }
        },
        patientsFail(state, action){
            return {
                loading: false,
                error:  action.payload
            }
        },
        patientsCatageoryRequest(state, action){
            return {
                loading: true
            }
        },
        patientsCatageorySuccess(state, action){
            return {
                loading: false,
                patients: action.payload.patients,
                patientsCount:action.payload.count,
                resPerPage:action.payload.resPerPage
            }
        },
        patientsCatageoryFail(state, action){
            return {
                loading: false,
                error:  action.payload
            }
        },
        adminPatientsRequest(state, action){
            return {
                loading: true
            }
        },
        adminPatientsSuccess(state, action){
            return {
                loading: false,
                patients: action.payload.patients,
            }
        },
        adminPatientsFail(state, action){
            return {
                loading: false,
                error:  action.payload
            }
        },
        clearError(state, action){
            return {
                ...state,
                error:  null
            }
        }
    }
});

const { actions, reducer } = patientsSlice;

export const { 
    patientsRequest, 
    patientsSuccess, 
    patientsFail,
    patientsCatageoryFail,
    patientsCatageoryRequest,
    patientsCatageorySuccess,
    adminPatientsFail,
    adminPatientsRequest,
    adminPatientsSuccess

} = actions;

export default reducer;